var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex-grid",
    { staticClass: "settings-list", attrs: { "flex-direction": "column" } },
    _vm._l(_vm.viewList, function(view) {
      return _c(
        "flex-grid-item",
        { key: view.name, attrs: { margin: "0" } },
        [
          _c("button-fill", {
            staticClass: "settings-list-item",
            attrs: {
              color: view.name === _vm.activeViewName ? "primary" : "tertiary",
              label: view.displayName
            },
            on: {
              click: function() {
                return _vm.onClick(view)
              }
            }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e118c3f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e118c3f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/settings-modal/components/settings-list.vue
// module id = 1576
// module chunks = 0